import React from 'react';
import resim_1 from '../assets/images/about/resim_1.jpg';
import resim_2 from '../assets/images/about/resim_2.jpg';
import piri_logo from '../assets/images/about/piri_logo.png';
import { FaCogs, FaMagic, FaBookOpen, FaClipboardList, FaLightbulb, FaPenFancy, FaEdit, FaSpellCheck, FaKey, FaSearch, FaFile, FaHighlighter, FaQuestionCircle, FaExpand, FaGlobe, FaLanguage, FaShareAlt, FaCloudDownload, FaChartLine, FaBrain } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';


const PrivacyPage = ({ isOpen, onClose }) => {
                const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative bg-white w-[90vw] max-w-6xl max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div className="space-y-12">

                        {/* Left Column - Text Content */}
                    <div className="space-y-12">

                        <h2 className="text-2xl font-semibold text-[#3c4f58] mb-4"> Piri AI: {t('privacyPolicy.heading')}</h2>
                 <p className="text-justify text-gray-700">
      {t('privacyPolicy.intro')}
      <br/><br/>
      <strong>{t('privacyPolicy.dataCollection.title')}</strong><br/>
      {t('privacyPolicy.dataCollection.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.storageSecurity.title')}</strong><br/>
      {t('privacyPolicy.storageSecurity.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.sharing.title')}</strong><br/>
      {t('privacyPolicy.sharing.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.corporateStats.title')}</strong><br/>
      {t('privacyPolicy.corporateStats.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.userRights.title')}</strong><br/>
      {t('privacyPolicy.userRights.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.cookiePolicy.title')}</strong><br/>
      {t('privacyPolicy.cookiePolicy.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.retention.title')}</strong><br/>
      {t('privacyPolicy.retention.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.securityMeasures.title')}</strong><br/>
      {t('privacyPolicy.securityMeasures.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.policyChanges.title')}</strong><br/>
      {t('privacyPolicy.policyChanges.text')}
      <br/><br/>
      <strong>{t('privacyPolicy.contact.title')}</strong><br/>
      {t('privacyPolicy.contact.text')}
    </p>



                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;